import React from 'react';
import { Button } from 'antd';
import AccentButton from '../AccentButton/AccentButton';
import './EditingBar.css';

interface EditingBarProps {
  icon: React.ReactNode;
  title: string;
  onCancel: () => void;
  onSave?: () => void;
}

const EditingBar: React.FC<EditingBarProps> = ({ icon, title, onCancel, onSave }) => {
  return (
    <div className="editing-bar">
      <div className="editing-bar__left">
        {icon}
        <span className="editing-bar__title">{title}</span>
      </div>
      <div className="editing-bar__actions">
        <Button
          size="small"
          shape="round"
          className="editing-bar__cancel"
          onClick={onCancel}
        >
          Cancel
        </Button>
        {onSave && (
          <AccentButton size="small" shape="round" onClick={onSave}>
            Save
          </AccentButton>
        )}
      </div>
    </div>
  );
};

export default EditingBar;
